// extracted by mini-css-extract-plugin
export default {"InfoTable":"styles_InfoTable__G0z9f","InfoTablePopup":"styles_InfoTablePopup__1d5Iq","label":"styles_label__zqf62"};